import React, { useEffect, useState, useRef } from "react";
import DataTables from "../../CommonDataTable/DataTable";
import config from "../../../../config/config";
import apiCalls from "../../../../config/apiCalls";
import ViewModal from "../../CommonModals/viewModal";
import NewUserModal from "../../CommonModals/NewUserModal";
import showToasterMessage from "../../../UI/ToasterMessage/toasterMessage";
import FormModal from "../../../Form/FormModal";
import store from "../../../App/store";
import filePath from "../../../../config/configSampleFiles";
import fetchMethodRequest from "../../../../config/service";
import RolePermissions from "../../CommonModals/Permissions";
import { useParams } from "react-router";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { marked } from 'marked';
// import AudioPlayer from "./AudioPlayer";
// config file

const Recordings = (props) => {
  const [languageData, setLanguageData] = useState();
  const [rolePermission, setRolePermission] = useState();
  const [editSelectedRecord, setEditSelectedRecord] = useState(
    window.location.href.includes("edit")
  );
  const [addSelectedRecord, setAddSelectedRecord] = useState(
    window.location.href.includes("create")
  );
  const [viewSelectedRecord, setViewSelectedRecord] = useState(
    window.location.href.includes("view")
  );
  const [isOpenFormModal, setIsOpenFormModal] = useState(false);
  const [openNewUserModal, setopenNewUserModal] = useState(false);
  const [item, setItem] = useState({});
  const [newFormFields, setNewFormField] = useState([]);

  let user = localStorage.getItem('loginCredentials') ? JSON.parse(localStorage.getItem('loginCredentials')) : {};
  let dataTableRef = useRef(null);
  const params = useParams();
  useEffect(() => {
    let screenPermissions = RolePermissions.screenPermissions("Recordings");
    if (screenPermissions) {
      setRolePermission(screenPermissions);
    }
  }, []);

  const setData = (props) => {
    let rowData = {};
    if (params.id) {
      rowData["_id"] = JSON.parse(params.id);
      return rowData;
    }
  };

  const getTableFields = () => {
    let roleTypes = [
      {
        label: "All",
        value: null,
      },
      {
        label: "Admin",
        value: "Admin",
      },
      {
        label: "Super Admin",
        value: "Super Admin",
      },
      {
        label: "User",
        value: "User",
      },
    ];
    let statusTypes = [
      {
        label: "All",
        value: null,
      },
      {
        label: "Active",
        value: "Active",
      },
      {
        label: "Inactive",
        value: "Inactive",
      },
      {
        label: "Pending",
        value: "Pending",
      },
    ];
    let data = [
      // {
      //   textAlign: "center",
      //   width: 47,
      //   field: "Check Box",
      //   label: "Check Box",
      //   fieldType: "multiple",
      //   header: "",
      //   selectionMode: "multiple",
      //   show: true,
      //   mobile: true,
      //   displayInSettings: true,
      //   displayinlist: "false",
      //   displayinaddForm: "false",
      //   displayineditForm: "false",
      //   globalSearchField: "false",
      //   isFieldRequired: "false",
      //   tDisplay: true,
      // },
      {
        textAlign: "center",
        width: "5%",
        field: "Sno",
        label: "SNo",
        header: "SNo",
        filter: false,
        sortable: false,
        placeholder: "Search",
        displayinlist: "false",
        displayinaddForm: "false",
        displayineditForm: "false",
        globalSearchField: "false",
        isFieldRequired: "false",
        show: true,
        mobile: true,
        displayInSettings: true,
        tDisplay: true,
      },
      {
        name: "name",
        fieldName: "name",
        type: "text",
        placeholder: "Name",
        value: "",
        label: "Name",
        width: "20%",
        addFormOrder: 10,
        editFormOrder: 10,
        stringType: null,
        header: "Name",
        derivedValue: "name=undefined",
        capitalizeTableText: false,
        sortable: true,
        filter: true,
        id: "name",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinregisterForm: false,
        displayinlist: "true",
        isFieldRequired: "false",
        required: false,
        displayOptionsInActions: "",
        globalSearchField: "true",
        controllerId: null,
        isClickable: "",
        isAddToIndex: false,
        isBulkUploadField: true,
        textAlign: "left",
        show: true,
        field: "name",
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
        fieldType: "Link",
        style: {
          color: "#0e4768",
          cursor: "pointer",
          textTransform: "capitalize",
        },
        tDisplay: true,
      },
      {
        name: "transcription",
        fieldName: "transcription",
        type: "text",
        placeholder: "transcription",
        value: "",
        label: "Transcription",
        width: "50%",
        addFormOrder: 10,
        editFormOrder: 10,
        stringType: null,
        header: "Transcription",
        derivedValue: "transcription=undefined",
        capitalizeTableText: false,
        sortable: true,
        filter: true,
        id: "transcription",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinregisterForm: false,
        displayinlist: "true",
        isFieldRequired: "false",
        required: false,
        displayOptionsInActions: "",
        globalSearchField: "true",
        controllerId: null,
        isClickable: "",
        isAddToIndex: false,
        isBulkUploadField: true,
        textAlign: "left",
        show: true,
        field: "transcription",
        showOrHideFields: [],
        mobile: false,
        displayInSettings: true,
        tDisplay: true,
        style: { width: '90%', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }
      },
      {
        name: "created",
        type: "date",
        placeholder: "Created",
        label: "Created",
        width: "15%",
        header: "Created",
        derivedValue: "created=undefined",
        actions: [],
        actionsNumber: [],
        id: "created",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "true",
        globalSearchField: "true",
        controllerId: null,
        fieldType: "Date",
        dateFormat: config.recentDateFormat,
        textAlign: "Center",
        disabled: true,
        show: true,
        field: "created",
        isFieldRequired: "false",
        mobile: true,
        displayInSettings: true,
        tDisplay: true,
      },
      {
        show: true,
        textAlign: "center",
        width: "10%",
        fieldType: "Actions",
        field: "Actions",
        header: "Actions",
        label: "Actions",
        filter: false,
        sortable: false,
        displayInSettings: true,
        displayinServer: "false",
        displayinlist: "true",
        displayinaddForm: "true",
        displayineditForm: "true",
        globalSearchField: "false",
        isFieldRequired: "false",
        mobile: true,
        tDisplay: true,
      },
    ];
    return data;
  };

  const getFormFields = () => {
    let statusTypes = [
      {
        label: "Active",
        value: "Active",
      },
      {
        label: "Inactive",
        value: "Inactive",
      },
      {
        label: "Pending",
        value: "Pending",
      },
    ];
    return [
      {
        name: "name",
        fieldName: "name",
        type: "text",
        placeholder: "Name",
        value: "",
        label: "Name",
        width: "120px",
        addFormOrder: 1,
        editFormOrder: 1,
        stringType: null,
        derivedValue: "name=undefined",
        capitalizeTableText: false,
        sortable: true,
        filter: true,
        id: "name",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinregisterForm: false,
        displayinlist: "true",
        isFieldRequired: "false",
        required: true,
        displayOptionsInActions: "",
        globalSearchField: "true",
        controllerId: null,
        isClickable: "",
        isAddToIndex: false,
        isBulkUploadField: true,
        show: true,
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
        fieldType: "Link",
        style: {
          color: "#0e4768",
        },
        isAddFormHidden: false,
        isEditFormHidden: false,
        capitalizeValue: true
      },
    ];
  };

  const submit = async (item) => {
    setIsOpenFormModal(true);
    // await this.formModalRef.getRowData(item, 'edit');
    console.log("Submit Button in sode          ");
  };

  const closeFormModal = async () => {
    setIsOpenFormModal(false);
  };

  const cancelReset = async (type) => {
    setopenNewUserModal(false);
    // window.location.reload();
    if (dataTableRef.current) {
      const { getDataFromServer, filterCriteria } = await dataTableRef.current;
      getDataFromServer(filterCriteria);
    }
  };

  const saveDataToServer = async (item, field, value) => {
    let userBody;
    if (item?.length > 0 && field && value) {
      let selectedIds = item.map((row) => row._id);
      userBody = {
        selectedIds: selectedIds,
        updatedDetails: { [field]: value },
      };
    } else {
      return;
    }
    if (userBody) {
      let method, apiUrl;
      method = "POST";
      apiUrl = `${apiCalls.recordings}/multiUpdate`;
      return fetchMethodRequest(method, apiUrl, userBody)
        .then(async (response) => {
          if (response && response.respCode) {
            showToasterMessage(response.respMessage, "success");
          } else if (response && response.errorMessage) {
            showToasterMessage(response.errorMessage, "error");
          }
        })
        .catch((err) => {
          return err;
        });
    } else {
      return;
    }
  };

  const isEditPermission = rolePermission?.type == "Edit" ? true : false;
  const actionTypes = [
    {
      name: "Delete",
      options: [
        {
          label: "Delete",
          value: "Delete",
          show: rolePermission?.actions?.includes("Delete") ? true : false,
          multiple: true,
        },
      ],
    },
  ];
  const rowExpansionTemplate = (rowData) => {
    return (
      <div className="expansion-content">
        <AudioPlayer rowData={rowData} />
      </div>
    );
  };
  // Helper Component for truncating long text
  const ReadMore = ({ content, limit = 300, isHtml = false }) => {
    const [isExpanded, setIsExpanded] = useState(false);

    // Function to strip HTML tags for length check
    const stripHtml = (html) => {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      return doc.body.textContent || "";
    };

    const textContent = isHtml ? stripHtml(content) : content;
    const shouldTruncate = textContent.length > limit;

    if (!shouldTruncate) {
      return isHtml ? <div dangerouslySetInnerHTML={{ __html: content }} /> : <p>{content}</p>;
    }

    return (
      <div className="read-more-wrapper">
        <div className={`read-more-content ${isExpanded ? 'expanded' : 'collapsed'}`}>
          {isHtml ? (
            <div dangerouslySetInnerHTML={{ __html: content }} />
          ) : (
            <p>{content}</p>
          )}
        </div>
        <button
          className="read-more-toggle"
          onClick={() => setIsExpanded(!isExpanded)}
        >
          {isExpanded ? 'Show Less' : 'Read More...'}
        </button>
      </div>
    );
  };


  const AudioDataDisplay = (data) => {
    if (!data) return null;

    return (
      <div className="minimal-display structural-view">
        {/* Main Heading */}
        <div className="main-heading">
          <div className="title-section">
            <h1>{data.name}</h1>
            <div className="meta-info">
              <span>{new Date(data.created).toLocaleDateString()}</span>
              {data.duration && <span className="separator">•</span>}
              {data.duration && <span>{data.duration}</span>}
            </div>
          </div>
          <div className="status">
            <span className={`status-badge ${data.active ? 'active' : 'inactive'}`}>
              {data.active ? 'Active' : 'Inactive'}
            </span>
          </div>
        </div>

        <div className="content-container">
          <div className="content-section card-style">
            <h2>Summary</h2>
            <div className="content-body">
              <ReadMore content={data?.summary} isHtml={true} limit={250} />
            </div>
          </div>

          {data.meeting_summary && (
            <div className="content-section card-style">
              <h2>Meeting Highlights</h2>
              <div className="content-body">
                <ReadMore content={data.meeting_summary} limit={200} />
              </div>
            </div>
          )}

          {data.mom && (
            <div className="content-section card-style">
              <h2>Minutes of Meeting</h2>
              <div className="content-body">
                <div className="mom-vertical">
                  <div className="mom-subsection">
                    <h3>Discussion Points</h3>
                    {data.mom?.discussion_points?.length > 0 ? (
                      <ul>
                        {data.mom.discussion_points.map((point, index) => (
                          <li key={index}>{point}</li>
                        ))}
                      </ul>
                    ) : (
                      <p>No discussion points</p>
                    )}
                  </div>
                  <div className="mom-subsection">
                    <h3>Decisions</h3>
                    {data.mom?.decisions?.length > 0 ? (
                      <ul>
                        {data.mom.decisions.map((decision, index) => (
                          <li key={index}>{decision}</li>
                        ))}
                      </ul>
                    ) : (
                      <p>No decisions</p>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}

          {data.follow_ups && data.follow_ups.length > 0 && (
            <div className="content-section card-style">
              <h2>Action Items</h2>
              <div className="content-body">
                <div className="follow-ups">
                  {data.follow_ups.map((followUp, index) => (
                    <div key={index} className="follow-up">
                      <h4>{followUp.task || 'No task specified'}</h4>
                      <div className="follow-up-meta">
                        <span>Owner: {followUp.owner || 'Unassigned'}</span>
                        {followUp.deadline && (
                          <span>Due: {new Date(followUp.deadline).toLocaleDateString()}</span>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}

          {data.transcription && (
            <div className="content-section card-style">
              <h2>Transcription</h2>
              <div className="content-body">
                <ReadMore content={data.transcription} limit={400} />
              </div>
            </div>
          )}

          {data.corrected_text && (
            <div className="content-section card-style">
              <h2>AI Corrected Text</h2>
              <div className="content-body">
                <ReadMore content={data.corrected_text} isHtml={true} limit={300} />
              </div>
            </div>
          )}

          {/* Audio Player section at bottom */}
          <div className="audio-player-section-bottom">
            <h2>Audio Player</h2>
            <AudioPlayer audioPath={data.path} fileName={data.name} />
          </div>
        </div>
      </div>
    );
  };

  // Audio Player Component
  const AudioPlayer = ({ audioPath, fileName }) => {
    const match = audioPath?.match(/\/server\/upload\/.*$/);
    const cleanedPath = match ? match[0] : audioPath;
    const audioUrl = cleanedPath ? `${config.imgUrl}${cleanedPath}` : '';

    return (
      <audio
        src={audioUrl}
        controls
        style={{
          width: '100%',
          height: '60px',
          borderRadius: '8px',
          '--plyr-color-main': '#12225f',
          '--plyr-audio-control-color': '#12225f',
          '--plyr-audio-control-color-hover': '#c88ffa',
          '--plyr-range-thumb-background': '#c88ffa',
          '--plyr-range-fill-background': '#c88ffa',
          '--plyr-tooltip-background': '#12225f',
          '--plyr-tooltip-color': '#ffffff'
        }}
      />
    );
  };




  return (
    <span>
      {
        <DataTables
          onRef={(ref) => (dataTableRef.current = ref)}
          {...props}
          getTableFields={getTableFields}
          formFields={getFormFields}
          addRequired={false}
          editRequired={true}
          deleteRequired={true}
          viewRequired={true}
          exportRequired={false}
          sample={false}
          printRequried={false}
          actionsTypes={false}
          settingsRequired={false}
          filterRequired={false}
          gridRequried={false}
          exportToCsv={false}
          dateSearchRequired={false}
          searchInDateRangeField={""}
          setData={setData}
          editSelectedRecord={editSelectedRecord}
          addSelectedRecord={addSelectedRecord}
          viewSelectedRecord={viewSelectedRecord}
          sampleFilePath={filePath.recordings}
          displayName="Scribe AI "
          type="Recordings"
          routeTo={apiCalls.recordings}
          displayViewOfForm="modal"
          sideFormLeftOrRight="right"
          apiResponseKey={apiCalls.recordings?.toLowerCase()}
          apiUrl={apiCalls.recordings}
          selectedId={params.id}
          displayActionsInTable={"actions"}
          filterClearRequired={true}
          hideActions={true}
          customViewModal={AudioDataDisplay}
        // expandRowRequired={true}
        // rowExpansionTemplate={rowExpansionTemplate}
        />
      }

    </span>
  );
};

export default Recordings;
